export enum ContactsListActionTypes {
  Init = '[Contact List] Init',

  ContactSelected = '[ContactsList Page] Contact Selected',
  ContactEnabled = '[ContactsList Page] Contact Enabled',
  ContactDisabled = '[ContactsList Page] Contact Disabled',

  ResetSelectedContact = '[ContactsList/Page] Reset Selected Contact',
  ResetSelection = '[ContactsList/Page] Reset Selection',
}
export enum ContactCreateUpdateActionTypes {
  Init = '[ContactCreateUpdate Page] Init',
  InitCreate = '[ContactCreateUpdate Page] Init Create',
  InitUpdate = '[ContactCreateUpdate Page] Init Update',

  ContactAdded = '[ContactCreateUpdate Page] Contact Added',
  ContactUpdated = '[ContactCreateUpdate Page] Contact Updated',

  Destroyed = '[ContactCreateUpdate/Page] Destroyed',
}

export enum ContactsLsosActionTypes {
  AddContact = '[Contacts/LSOS/Page] Add Contact',
  AddContactSuccess = '[Contacts/LSOS/Page] Add Contact Success',
  AddContactFailure = '[Contacts/LSOS/Page] Add Contact Failure',
}
